import { useTheme } from '@mui/material/styles';
import { CHART_All_DATASETS } from '../../shared/AppConstants';

export const CustomToolTip = ({
  active,
  payload = [],
  renameMap = null,
  title = ''
}) => {
  const theme = useTheme();
  if (!active) return null;

  const parseData = ({ value, key }) => {
    if (
      key === CHART_All_DATASETS.THIS_STRATEGY ||
      key === CHART_All_DATASETS.OTHER_STRATEGIES
    ) {
      return <span>{value.payload.values[key]}</span>;
    }
    return <span>{value.payload[key]}</span>;
  };

  return (
    <div
      style={{
        backgroundColor: theme.fuel6Tokens.JddcColorBackgroundStrong,
        borderRadius: 4,
        color: theme.fuel6Tokens.JddcColorTextInverse,
        fontSize: '0.875rem',
        fontWeight: 'normal',
        padding: '0.75rem',
        zIndex: 1
      }}
    >
      {title && <p>{`${title}`}</p>}
      {payload &&
        payload.map(
          (
            each: { dataKey: string; fill: string; payload: {} },
            index: number
          ) => {
            const key = each.dataKey.split('.').pop() ?? '';

            return (
              <div
                key={`${each.dataKey}-tooltip-${index}`}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginBottom: '0.25rem',
                  width: '100%'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '100%'
                  }}
                >
                  <span style={{ paddingRight: '13px' }}>
                    {`${renameMap?.[key] ?? each.dataKey} `}
                  </span>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {parseData({ value: each, key })}
                  </div>
                </div>
              </div>
            );
          }
        )}
    </div>
  );
};
